.styledIcon {
  &.enableHover:not(.isDisabled) {
    &:hover {
      transform: scale(1.25);
      cursor: pointer !important; /* stylelint-disable-line declaration-no-important */
    }
  }

  &.isDisabled {
    path {
      fill: var(--surface-default);
      stroke: var(--icon-disabled);
    }
  }
}
